export const GET_SERVER_RESPONSE_STATUS = 'GET_SERVER_RESPONSE_STATUS';
